import { render, staticRenderFns } from "./MaterialResource.vue?vue&type=template&id=25826f29&scoped=true&"
import script from "./MaterialResource.vue?vue&type=script&lang=js&"
export * from "./MaterialResource.vue?vue&type=script&lang=js&"
import style0 from "./MaterialResource.vue?vue&type=style&index=0&id=25826f29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25826f29",
  null
  
)

export default component.exports